// ======================================================================
// File Name       : AuthorityManagementFunctionDisplay
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { MANAGEMENT_AUTHORITY_DISPLAY_TYPE, MANAGEMENT_AUTHORITY_TYPE } from '../../constants/AuthorityConstant';

const AuthorityManagementFunctionDisplay = ({ label, name, value, onChange, isDisabled }) => (
  <Form.Group className="form-info">
    <Col sm={3} as={Form.Label}>{label}</Col>
    <Col lg={2} sm={3} className="padding-top-10">
      <Form.Check
        type='radio'
        inline
        className="padding-top-clear"
        name={name}
        id={`${name}-${MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY}`}
        value={MANAGEMENT_AUTHORITY_DISPLAY_TYPE.DISPLAY}
        checked={value === MANAGEMENT_AUTHORITY_TYPE.REFERENCE || value === MANAGEMENT_AUTHORITY_TYPE.REFERENCE_REGISTRATION_EDIT}
        onChange={onChange}
        disabled={isDisabled}
        label='表示'></Form.Check>
    </Col>
    <Col lg={2} sm={3} className="padding-top-10">
      <Form.Check
        type='radio'
        inline
        className="padding-top-clear"
        name={name}
        id={`${name}-${MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}`}
        value={MANAGEMENT_AUTHORITY_DISPLAY_TYPE.HIDE}
        checked={value === MANAGEMENT_AUTHORITY_TYPE.NOT_USED}
        onChange={onChange}
        disabled={isDisabled}
        label='非表示'></Form.Check>
    </Col>
  </Form.Group>
);

export default AuthorityManagementFunctionDisplay;
